import {getRandomBlurSymbolFrameName, wait} from "../utilites";
import {socketService} from "../socketService";
import {pixiComponents} from "../index";
import {freeSpinStore, spinStore, store} from "../store";
import {REEL, reelsStoppingAnimDelay, spinAnimationConfig, SYMBOLS} from "../constants/configs";
import * as PIXI from "pixi.js";
import {gsap} from "gsap";
import {hideWinAmountInfoText, updateSpinBtnState} from "../controlPanel";
import {stopAutoSpin} from "../controlPanel/autoSpin";
import {spinSound, stopReelSound} from "../soundService";
import {showFreeSinsLeftInfoText} from "../controlPanel/amountText";
import {showErrorToast} from "../notifications/toastNotificatons/toastNotification";
import {t, TKeys} from "../translationService";
import {hideTextWinFreeSpins, updateFreeBetBoard} from "../freeSpin";
import {DURATIONS} from "../constants/durations";

export const getDurations = (name) => {
    if (!DURATIONS.DURATION_NAMES[name]) {
        return 0;
    }
    return spinStore.getIsTurbo() || spinStore.isQuickFall ? DURATIONS.TURBO[name] : DURATIONS.DEFAULT[name];
};

export const getStores = () => ({freeSpinStore, spinStore, store});

export const spinControlPanel = {
    isAutoSpinning: false,
    isStartedReelsStopping: false,
    stopReelsByDelayTimeOutId: 0,
    reelsStoppingDelay: 0,
    isSpinning: false,
}

export const setComingSpinQuickFall = () => {
    if (spinStore.isQuickFall) {
        return;
    }

    spinStore.setIsQuickFall(true);
    const cleanUpPromise = pixiComponents.slotBoard.cleanUpPromise
    gsap.delayedCall(0.3, () => {
        if (cleanUpPromise === pixiComponents.slotBoard.cleanUpPromise) {
            pixiComponents.slotBoard.killGsapAnimations();
            pixiComponents.slotBoard.resolveCleanUpPromise();
        }
    });
}

export const handleSpinButton = async () => {
    hideTextWinFreeSpins();

    if (!(socketService.connection && socketService.connection.state === 'Connected')) {
        return;
    } else if (spinControlPanel.isSpinning) {
        setComingSpinQuickFall();
        return;
    }

    spinStore.setIsQuickFall(false);
    spinControlPanel.isSpinning = true;
    updateSpinBtnState(spinControlPanel);
    updateFreeBetBoard();
    pixiComponents.slotBoard.clear();
    socketService.spin(spinStore.spinAmount);
    pixiComponents.slotBoard.tumbleWinBoard.endTumbleSession();
}

export const handleSpinEnd = async () => {
    spinControlPanel.isSpinning = false;

    if (spinStore.autoSpinCountdown) {
        // if (store.lastWinAmount) {
        //     await wait(spinAnimationConfig.autoSpinWinShowDelay);
        // }
        if (spinStore.autoSpinCountdown) {
            handleSpinButton();
            spinStore.setAutoSpinCountdown(spinStore.autoSpinCountdown - 1);
        }
    } else {
        spinControlPanel.isAutoSpinning = false;
        freeSpinStore.setCanBuyFreeSpin(true);
        updateFreeBetBoard();
        if (freeSpinStore.isBonusGameStarted) {
            freeSpinStore.setIsBonusGameStarted(false);
        }
    }

    if (freeSpinStore.freeSpin) {
        showFreeSinsLeftInfoText(freeSpinStore.freeSpin.quantity - freeSpinStore.freeSpin.usedQuantity - 1);
    }

    updateSpinBtnState(spinControlPanel);
}

export const stopReels = () => null;//old

export const spinReels = () => null;//old

export const setSlotBoardCards = (cards) => {
    if (!pixiComponents.symbolsContainers || !pixiComponents.symbolsContainers.length) {
        return;
    }
    pixiComponents.symbolsContainers.forEach((symbolsContainer, reelIndex) => {
        setReelSymbols(symbolsContainer, cards[reelIndex]);
    })
}

const setReelSymbols = (symbolsContainer, reelSymbols) => {
    symbolsContainer.children.forEach((symbol, i) => {
        symbol.filters = [];
        symbol.y = i * REEL.width - REEL.width / 2;
        if (i - 1 >= 0 && reelSymbols) {
            symbol.texture = PIXI.Texture.from(SYMBOLS[reelSymbols[i - 1]])
        }
    });
}
